import { Outlet } from 'react-router-dom';
import SubMenu, { SubMenuTitle } from 'components/SubMenu';
import Routes from 'constants/Routes';
import {
  isAuthorized,
  LasDaysAccessPolicy,
  WorkTimeReportAccessPolicy,
} from 'constants/Roles';
import useMe from 'contexts/authentication/useMe';

// "Hastighet & GPS" låg här t.o.m. 2026-09 och bor nu under Kvalitet
// (pages/Quality). LAS-dagar och Tidsrapport syns bara för rollen HR, inte för övriga som når
// HR-fliken.
const HRPage = () => {
  const me = useMe();

  const items = [
    {
      label: <SubMenuTitle>Grönskyltar</SubMenuTitle>,
      path: Routes.hr.greenplates,
    },
    ...(isAuthorized(
      LasDaysAccessPolicy.allow,
      LasDaysAccessPolicy.deny,
      me?.roles
    )
      ? [
          {
            label: <SubMenuTitle>LAS-dagar</SubMenuTitle>,
            path: Routes.hr.lasDays,
          },
        ]
      : []),
    ...(isAuthorized(
      WorkTimeReportAccessPolicy.allow,
      WorkTimeReportAccessPolicy.deny,
      me?.roles
    )
      ? [
          {
            label: <SubMenuTitle>Tidsrapport</SubMenuTitle>,
            path: Routes.hr.workTimeReport,
          },
        ]
      : []),
  ];

  return (
    <>
      <SubMenu items={items} />
      <Outlet />
    </>
  );
};

export default HRPage;
